import React, { useContext, useEffect } from 'react';
import styled from '@emotion/styled';
import TitleSearchLoadingCard from '@/components/OrderPlacement/OPTitleSearch/TitleSearchLoadingCard';
import OPViewingInventory from '@/components/OrderPlacement/OPStep2FileSelection/OPViewingInventory';
import OPViewingInventoryV2 from '@/components/OrderPlacement/OPStep2FileSelection/OPViewingInventoryV2';
import { OPViewingInventoryProps } from '@/components/OrderPlacement/OPStep2FileSelection/OPViewingInventory.types';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { selectFilters } from '@/redux/selectors/orderPlacementSelectors';
import { setInventoryModalSelectedFile } from '@/redux/slices/packagingSlice';
import { ConfigContext } from '@/contextAPI/configContext';

interface Props {
  initialVersionId?: number;
}

const FilesList: React.FC<Props> = ({ initialVersionId }) => {
  const isTitleV2 = useContext(ConfigContext)?.titleConfig?.v2;
  const dispatch = useAppDispatch();
  const filters = useAppSelector(selectFilters);

  useEffect(() => {
    dispatch(setInventoryModalSelectedFile(null));
  }, [filters]);

  const opViewingInventoryProps: OPViewingInventoryProps = {
    isPackagingInventory: true,
    initialVersionId
  };

  return (
    <Wrapper>
      <InventoryWrapper>
        <TitleSearchLoadingCard>
          {isTitleV2 ? <OPViewingInventoryV2 {...opViewingInventoryProps} /> : <OPViewingInventory {...opViewingInventoryProps} />}
        </TitleSearchLoadingCard>
      </InventoryWrapper>
    </Wrapper>
  );
};

export default FilesList;

const Wrapper = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  min-width: 300px;
  padding-top: ${({ theme }) => theme.spacing(7)};
`;

const InventoryWrapper = styled.div`
  flex-grow: 2;
  position: relative;
  padding: ${({ theme }) => theme.spacing(0, 3, 3, 3)};
  overflow-y: scroll;
  overflow-x: hidden;
`;
